import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { SHOW_MODIFY_FIELDS, SHOW_MODIFY_FIELDS_ERROR, SHOW_MODIFY_FIELDS_SUCCESS } from '../../../actions.js';

function* showModifyFields({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/modify-booking/fields`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: SHOW_MODIFY_FIELDS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SHOW_MODIFY_FIELDS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SHOW_MODIFY_FIELDS_ERROR, payload: error });
  }
}

export function* watchshowModifyFields() {
  yield takeEvery(SHOW_MODIFY_FIELDS, showModifyFields);
}

function* showModifyFieldsSaga() {
  yield all([fork(watchshowModifyFields)]);
}

export default showModifyFieldsSaga;
